import React from 'react'
import PropTypes from "prop-types"
import { isEqual } from 'lodash'
import { normalize } from 'path'

import { emptyPrice } from '../components/Price'
import HoverTip from '../components/HoverTip'
import { printMoney, round } from '../../lib/Tools'
import { getText } from '../lib/text'
import { normalizePrice } from '../../lib/prices'

function getItemPrice(item, Activities, referencedExpense, itemInTemplate) {
  if (item.type == "expense") return (referencedExpense || item.expense).price
  else if (item.type == "activity") {
    if (item.useCustomPrice) return item.customPrice
    else if (item.frozenPrice && !itemInTemplate) return item.frozenPrice
    else return Activities[item.id].price
  }
  else if (item.type == "city" && item.transport && item.transport.means) return item.transport.price
  else if (item.type == "fakeWrapper") return item.price
  else return ""
}

// @TODO make this code clearer pls

// #TODO #DUPLICATION with Price.jsx
const tag = (eur, withYuan) => (
  withYuan ? `${printMoney(eur)}€ (¥${printMoney(eur2yuan(eur))})` : `${printMoney(eur)}€`
)

export function renderItemPrice(item, Activities, referencedExpense, itemInTemplate) {
  const _price = getItemPrice(item, Activities, referencedExpense, itemInTemplate)

  if (item.type == "day") return ""
  else if (!_price) {
    return <span>0€/👨 </span>
  }
  else if (item.type == "expense" || item.type == "activity" || item.type == "city" || item.type == "fakeWrapper") {
    const price = normalizePrice(_price)

    if (price.perGroup) return <span>{`${price.general || 0}€/👪 `}</span>
    else if (price.ageAware) return (
      // #TODO #DUPLICATION with Price.jsx
      [
        `> ${price.agePrices.length ? "Mayores" : ""}: ${tag(price.general)}`,
        ...price.agePrices.map(({ age, price }) => `≤${age}: ${tag(price)}`)
      ].join(", ")
    )
    else return <span>{`${price.general || 0}€/👨 `}</span>
  }
  else return null
}

const VisualPriceTag = ({ billItem, trip, agendaItem, Activities, referencedExpense, itemInTemplate }) => {
  if (billItem && billItem.priceValue == 0) return <span>{"0.00€"}</span>

  if (!agendaItem) {
    // Just billItem with no agendaItem: happens bc "other_expenses" is a clusterfuck
    // @TODO refactor clusterfuck
    // return <span>{`${printMoney(billItem.priceValue || 0)}€`}</span>
    return (
      <div>
        <div><strong>Total: </strong>{(billItem.priceValue || 0).toFixed(2)}€</div>
        <div>{ renderItemPrice({type: "fakeWrapper", price: billItem.price}) }</div>
      </div>
    )
  }

  const a = (agendaItem.type == "activity" && Activities[agendaItem.id])

  return (a && !isEqual(agendaItem.frozenPrice, a.price) && !itemInTemplate)
    ? (
      <HoverTip text={getText("Precio ha cambiado desde que se añadió esta actividad a la ruta.")}>
        <div style={{ color: (agendaItem.useCustomFee || agendaItem.useCustomPrice ? "blue" : ""), fontStyle: "italic" }}>
          {renderItemPrice(agendaItem, Activities, referencedExpense, itemInTemplate)}{" *"}
        </div>
      </HoverTip>
    )
    : (
      <div style={{ color: (agendaItem.useCustomPrice ? "blue" : "") }}>
        {
          billItem && (
            <div>
              <strong>Total: </strong>
              {round(billItem.priceValue * (billItem.numRepetitions || 1), 0.01).toFixed(2)}
              €
            </div>
          )
        }
        { renderItemPrice(agendaItem, Activities, referencedExpense, itemInTemplate) }
        {
          (billItem && billItem.numRepetitions && billItem.numRepetitions > 1 && <div>{"(por día)"}</div>)
        }
      </div>
    )
}

VisualPriceTag.propTypes = {
  agendaItem: PropTypes.object.isRequired,
  Activities: PropTypes.object.isRequired,

  referencedExpense: PropTypes.object,
  billItem: PropTypes.object,
  trip: PropTypes.object,
  itemInTemplate: PropTypes.bool
}

VisualPriceTag.defaultProps = {
  itemInTemplate: false
}

export default VisualPriceTag
